<template>
  <z-card
    ref="listItem"
    class="card-list-item"
    width="100%"
    shadow
    tabindex="0"
    :draggable="draggable"
    :color="backgroundColor"
    :dark="dark"
    :title="title"
    @dragstart="onDragStart"
    @dragend="onDragEnd"
    @drag="$emit('drag', $event)"
    @dragenter="$emit('dragenter', $event)"
    @dragleave="$emit('dragleave', $event)"
    @dragover="$emit('dragover', $event)"
    @drop="$emit('drop', $event)"
    @click="$emit('click')"
  >
    <template #content>
      <div class="card-list-item-content">
        <div class="content">
          <slot></slot>
        </div>

        <div class="card-list-item-actions-container">
          <slot name="actions">
            <template v-for="(action, index) of actions">
              <v-tooltip :key="index" top>
                <template v-slot:activator="{on, attrs}">
                  <v-icon
                    class="mx-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="$emit('action', action)"
                  >
                    {{ action.icon }}
                  </v-icon>
                </template>
                <span>{{ action.tooltip }}</span>
              </v-tooltip>
            </template>
          </slot>
        </div>
      </div>
    </template>
  </z-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Array de objetos no formato:
     * {tooltip: string, icon: string}
     */
    actions: {
      type: Array,
    },
  },

  methods: {
    /**
     * O objetivo desse método é alterar a imagem do card está sendo arrastado
     */
    onDragStart(evt) {
      //cria um elemento temporário para ser o elemento que está sendo arrastado
      const dragDiv = document.createElement('div')
      const cardWidth = this.$refs.listItem.$el.offsetWidth
      const cardHeight = this.$refs.listItem.$el.offsetHeight
      const cardTitle =
        this.$refs.listItem.$el.firstChild.firstChild.textContent

      //estiliza o elemento temporário
      dragDiv.id = `dragging-element`
      dragDiv.style.width = `${cardWidth - (30 / 100) * cardWidth}px`
      dragDiv.style.height = `${cardHeight}px`
      dragDiv.style.borderRadius = `var(--component-card-radius)`
      dragDiv.style.backgroundColor = 'var(--black-100)'
      dragDiv.style.padding = '10px'
      dragDiv.style.fontSize = '12px'
      dragDiv.innerHTML = `<p><strong>${cardTitle.toUpperCase()}</strong></p>`

      //adiciona o elemento temporário ao body
      document.body.appendChild(dragDiv)

      evt.dataTransfer.setDragImage(dragDiv, cardWidth / 3, cardHeight / 2)
      this.$emit('dragstart', evt)
    },

    onDragEnd(evt) {
      const dragDiv = document.getElementById('dragging-element')

      //remove o elemento temporário do body
      if (dragDiv.parentNode) {
        dragDiv.parentNode.removeChild(dragDiv)
      }

      this.$emit('dragend', evt)
    },
  },
}
</script>

<style lang="scss" scoped>
.card-list-item {
  padding: 12px 15px;
  height: fit-content;
  margin-bottom: 8px;
}

.card-list-item-content {
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 0;
}

.card-list-item-actions-container {
  display: flex;
  align-items: center;
}
</style>
